import { Dialog } from "primereact/dialog"
import { PlanoType } from "../../db/Orm"
import { DocumentoAntecipacao } from "../components/DocumentoAntecipacao"
import { useEffect, useRef, useState } from "react"
import { GeracaoDocumento } from "../components/GeracaoDocumento"
import { Toast } from "primereact/toast"

export type RequerimentoFields = 'requerimento' | 'requerimento_assinado_produtor'
const DIALOG_HEADERS: Record<RequerimentoFields, string> = {
    requerimento: 'Requerimento',
    requerimento_assinado_produtor: 'Requerimento - Assinatura do Produtor'
}
type LoadedRequerimentosType = Record<RequerimentoFields, null|{url: string, file:File}>

type RequerimentoAntecipacaoProps = {
    visible: boolean
    hide: ()=>void
    antecipacao: PlanoType
    carregarPlanos: ()=>Promise<void>|(()=>void)
    requerimentoField: RequerimentoFields
}
export const DialogRequerimentoAntecipacao = (props: RequerimentoAntecipacaoProps)=>{
    const [initialFile, setInitialFile] = useState<File|null|undefined>(props.antecipacao[props.requerimentoField] ? undefined : null)
    useEffect(()=>{
        setInitialFile(props.antecipacao[props.requerimentoField] ? undefined : null)
    }, [props.antecipacao[props.requerimentoField]])
    const loadedRequerimentos = useRef<LoadedRequerimentosType>({requerimento: null, requerimento_assinado_produtor: null})
    const toast = useRef<Toast>(null)
    return <Dialog header={DIALOG_HEADERS[props.requerimentoField]} visible={props.visible} onHide={props.hide} >
        <Toast ref={toast} position='center' />
        {!props.antecipacao.requerimento && <GeracaoDocumento antecipacao={props.antecipacao} documento='requerimento' toastRef={toast}
        carregarPlanos={props.carregarPlanos} />}
        {props.antecipacao.requerimento && <DocumentoAntecipacao antecipacao={props.antecipacao} carregarPlanos={props.carregarPlanos}
            documentoField={props.requerimentoField} tipoDocumento="Requerimento" initialFile={initialFile} setInitialFile={setInitialFile}
            loadedFiles={loadedRequerimentos.current} permitirEnvio={props.requerimentoField !== 'requerimento'} toastRef={toast} />}
    </Dialog>
}